/* models/callbacks/callback.js */ function _(require, module, exports) {
    const model_1 = require(64) /* ../../model */;
    class Callback extends model_1.Model {
        constructor(attrs) {
            super(attrs);
        }
    }
    exports.Callback = Callback;
    Callback.__name__ = "Callback";
}
